export default {"src":"/_next/static/media/time.59638513.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};